
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/jobs",
      function () {
        return require("private-next-pages/community/jobs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/jobs"])
      });
    }
  